module.exports = __webpack_public_path__ + "img/sec5desk.1b98393b.png";